import { Component, OnInit } from '@angular/core';
import { IMyOptions, MDBModalRef, ToastService, MDBModalService } from 'ng-uikit-pro-standard';
import { FormGroup, FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-new-task-modal',
  templateUrl: './new-task-modal.component.html',
  styleUrls: ['./new-task-modal.component.scss']
})
export class NewTaskModalComponent implements OnInit {
  public myDatePickerOptions: IMyOptions = {
    // Your options
  };
  public _formEntityTask: FormGroup;
  titleModal: string;
  customerSelect: any;

  currentDate: any;
  salesLeadsId: any;
  min = 0;
  max = 100;

  action: Subject<any> = new Subject<any>();
  //Options select
  optionsResponsiblAndResurces: any;
  optionsTaskStatus: any;
  optionsTaskCategory: any;
  optionsTaskPhase: any;
  optionsTaskPriority: any;
  optionsVendorSub: any;
  optionsSummaryTask: any;
  optionsTaskLocation: any;


  currentyear: number;
  currentMont: number;
  currectDay: number;

  constructor(
    private toast: ToastService,
    public modalRef: MDBModalRef,
    public GeneralService: GeneralService,
    private route: ActivatedRoute,
    private modalService: MDBModalService,
    private router: Router,
    private translate:TranslateService
  ) {
     this.titleModal = "New Task";
    this.customerSelect = [];
    setTimeout(() => {
      $('.modal').css('overflow-y', 'auto');
    }, 1000);
  }

  ngOnInit() {
    this.getcurrentDate();
    this.initForm();
    let datas;
    datas = this.modalService.config.data;
    this.salesLeadsId = parseInt(datas.customerSelect);
    this.getDataPopulate();
  }

  closeModal() {
    this.modalRef.hide();
  }

  initForm() {
    this._formEntityTask = new FormGroup({
      taskid: new FormControl({ value: 0, disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, []),
      projectid: new FormControl({ value: '', disabled: false }, []),
      projectaddress: new FormControl({ value: '', disabled: false }, []),
      employeeid: new FormControl({ value: 1, disabled: false }, []),
      resources: new FormControl({ value: 1, disabled: false }, []),
      statusid: new FormControl({ value: 1, disabled: false }, []),
      todocategoryid: new FormControl({ value: 1, disabled: false }, []),
      priorityid: new FormControl({ value: 1, disabled: false }, []),
      area: new FormControl({ value: " ", disabled: false }, []),
      phaseid: new FormControl({ value: 1, disabled: false }, []),
      estimatedcost: new FormControl({ value: 0, disabled: false }, [Validators.required]),
      startdate: new FormControl({ value: this.currentDate, disabled: false }, []),
      estimatedtime: new FormControl({ value: '00:01', disabled: false }, [Validators.required]),
      duedate: new FormControl({ value: this.currentDate, disabled: false }, []),
      completionperc: new FormControl({ value: 0, disabled: false }, []),
      endofmonthproj: new FormControl({ value: 0, disabled: false }, []),
      completiondate: new FormControl({ value: null, disabled: false }, []),
      inspected: new FormControl({ value: 0, disabled: false }, []),
      approved: new FormControl({ value: 0, disabled: false }, []),
      notes: new FormControl({ value: '', disabled: false }, []),
      sort: new FormControl({ value: '', disabled: false }, []),
      locationid: new FormControl({ value: 1, disabled: false }, []),
      parentid: new FormControl({ value: 1, disabled: false }, []),
      Createdon: new FormControl({ value: '', disabled: false }, []),
      Createdby: new FormControl({ value: '', disabled: false }, []),
      vendorid: new FormControl({ value: 1, disabled: false }, []),
      milstone: new FormControl({ value: '', disabled: false }, []),
    });
  }
  currentdateopts() {
    let f = new Date();
    this.currentyear = f.getFullYear()
    this.currentMont = (f.getMonth() + 1);
    this.currectDay = (f.getDate());
    this.myDatePickerOptions = {
      disableDateRanges: [{ begin: { year: 2013, month: 1, day: 1 }, end: { year: this.currentyear, month: this.currentMont, day: this.currectDay } }], // Disable date ranges.
    }
  }

  getDataPopulate() {
    this.GeneralService.GetEmployees().subscribe(result => {
      this.optionsResponsiblAndResurces = result.map((val) => {
        return { // Return the new object structure
          label: val.CONTACTNAME, value: val.ID
        };
      });
      console.log('optionsResponsiblAndResurces', this.optionsResponsiblAndResurces);
    });
    this.GeneralService.getPopulateGeneral('TaskStatus').subscribe(result => {
      this.optionsTaskStatus = result.map((val) => {
        return { // Return the new object structure
          label: val.NAME, value: val.ID
        };
      });
      console.log('optionsTaskStatus', this.optionsTaskStatus);
    });
    this.GeneralService.getPopulateGeneral('TaskCategory').subscribe(result => {
      this.optionsTaskCategory = result.map((val) => {
        return { // Return the new object structure
          label: val.TODOCATEGORY, value: val.ID
        };
      });
      console.log('optionsTaskCategory', this.optionsTaskCategory);
    });
    this.GeneralService.getPopulateGeneral('TaskPhase').subscribe(result => {
      this.optionsTaskPhase = result.map((val) => {
        return { // Return the new object structure
          label: val.NAME, value: val.ID
        };
      });
      console.log('optionsTaskPhase', this.optionsTaskPhase);
    });
    this.GeneralService.getPopulateGeneral('TaskPriority').subscribe(result => {
      this.optionsTaskPriority = result.map((val) => {
        return { // Return the new object structure
          label: val.Description, value: val.ID
        };
      });
      console.log('optionsTaskPriority', this.optionsTaskPriority);
    });
    this.GeneralService.getPopulateGeneral('Vendor', null, { id: this.salesLeadsId }).subscribe(result => {
      this.optionsVendorSub = result.map((val) => {
        return { // Return the new object structure
          label: val.VENDORNAME, value: val.ID
        };
      });
      console.log('optionsVendorSub', this.optionsVendorSub);
    });
    this.GeneralService.getPopulateGeneral('SummaryTask', null, { id: this.salesLeadsId }).subscribe(result => {
      this.optionsSummaryTask = result.map((val) => {
        return { // Return the new object structure
          label: val.DESCRIPTION, value: val.ID
        };
      });
      console.log('optionsSummaryTask', this.optionsSummaryTask);
    });
    this.GeneralService.getPopulateGeneral('TaskLocation').subscribe(result => {
      this.optionsTaskLocation = result.map((val) => {
        return { // Return the new object structure
          label: val.NAME, value: val.ID
        };
      });
      console.log('optionsTaskLocation', this.optionsTaskLocation);
    });

  }

  editDataTask(item) {
    this.titleModal = "Edit Task";
  }
  submitForm(savenew?, edit?) {
    let formValue;
    formValue = this._formEntityTask.value;
    if (formValue.name === "") {
      formValue.name = 'New Task'
    }
    formValue.projectid = parseInt(this.salesLeadsId);
    //Quitar - de fecha
    if(formValue.completiondate){
      formValue.completiondate = formValue.completiondate.replace('-', "");
    }
    formValue.duedate = formValue.duedate.replace('-', "");
    formValue.startdate = formValue.startdate.replace('-', "");
    formValue.duedate = formValue.duedate.replace('-', "");
    formValue.startdate = formValue.startdate.replace('-', "");

    //
    if (formValue.milstone === "") {
      formValue.milstone = false;
    }
    if (formValue.sort === "") {
      formValue.sort = 0;
    }

    // completionperc
    formValue.completionperc = parseInt(formValue.completionperc);
    formValue.estimatedcost = parseInt(formValue.estimatedcost);
    console.log('Task formValue', formValue);

    formValue.estimatedtime = parseFloat(formValue.estimatedtime.replace(':', "."));
    delete formValue.Createdon;
    delete formValue.Createdby;
    this.GeneralService.postInsertUpdategeneral('Task/InsertUpdateTask', null, formValue).subscribe(
      data => {
        console.log('InsertUpdateTask', data);
        this.toast.success(this.translate.instant('msgTaskCreSucc'));
        this.action.next({ success: true, data: data[0].Column1 });
        if (savenew === true) {
          this.initForm();
          this.action.next({ success: true, data: data[0].Column1 });

        }
        this.initForm();
        if (edit === true) {

          this.router.navigateByUrl('http://localhost:4200/taskManagement/editTask/' + data[0].Column1);

        }

      }
      , err => {
        console.log(err);
        this.toast.error('Error Creating Task');

      }
    )
  }

  getcurrentDate() {
    let f = new Date();
    let month: string;
    let day: string;

    if ((f.getMonth() + 1) < 10) {
      month = '0' + (f.getMonth() + 1);
    } else {
      month = (f.getMonth() + 1) + '';
    }
    if ((f.getDate()) < 10) {
      day = '0' + (f.getDate());
    } else {
      day = (f.getDate()) + '';
    }
    this.currentDate = (f.getFullYear() + "-" + (month) + "-" + day);
  }

}
